import { faHandshake } from "@fortawesome/pro-light-svg-icons";
import DashboardCard, { DashboardCardValueContent } from "../DashboardCard";
import { useThunkDispatch } from "setup/redux/thunkDispatch";
import { useSelector } from "react-redux";
import {
  getProposedWorks,
  selectLoadingProposedWorks,
  selectProposedWorks,
} from "app/modules/proposedWorks/components/ProposedWorksTableSlice";
import { useEffect } from "react";
import { ClientPortalProposedWorkFiltersModel } from "services/api/cplapi/CPLAPI";
import { ProposedWorkStatusTypes } from "global/enums";

const YourProposedWorksCard = () => {
  const thunkDispatch = useThunkDispatch();
  const proposedWorks = useSelector(selectProposedWorks);
  const loadingProposedWorks = useSelector(selectLoadingProposedWorks);

  useEffect(() => {
    const proposedWorkFilters = new ClientPortalProposedWorkFiltersModel({
      includeArchived: false,
    });
    thunkDispatch(getProposedWorks({ proposedWorkFilters }));
  }, [thunkDispatch]);

  const requiringPayment = proposedWorks.filter(
    (pw) => pw.proposedWorkStatusID === ProposedWorkStatusTypes["Awaiting Client Funds"]
  );

  const requiringVotes = proposedWorks.filter(
    (pw) => pw.proposedWorkStatusID === ProposedWorkStatusTypes["Awaiting Client Votes"]
  );

  return (
    <DashboardCard
      key={2}
      title="Your Major Works"
      icon={faHandshake}
      isBusy={loadingProposedWorks}
      bodyContent={
        <div>
          <DashboardCardValueContent value={requiringPayment.length} text={"Major Works requiring payment"} />
          <DashboardCardValueContent value={requiringVotes.length} text={"Major Works requiring votes"} />
        </div>
      }
      button={{ link: "/majorworks?requiresaction=true", text: "View Major Works" }}
      data-test-id="dashboard__view-major-works-link"
    />
  );
};

export default YourProposedWorksCard;
